import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const panelStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.875rem;
	padding: 1.25rem;
	border-radius: ${theme.radii.xlarge};
	background-color: ${theme.colors.surface};
	border: 1.5px solid ${theme.colors.border};
`;

const eyebrowStyle = css`
	${theme.typography.eyebrow}
	text-transform: uppercase;
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly title: string;
	readonly children: React.ReactNode;
};

/** A surface titled by a monospace eyebrow, holding people lists or the text around them. */
const PeoplePanel: React.FC<Props> = ({ title, children }) => {
	return (
		<section css={panelStyle}>
			<span css={eyebrowStyle}>{title}</span>
			{children}
		</section>
	);
};

export default PeoplePanel;
